export const inputThemeUpdated = {
  border: {
    bottom: '1px',
  },
};
